export const environment = {
    production: true,
    hmr: false,
    gqlLink: 'https://gql.spekwo.com/graphql',
    website: 'https://www.spekwo.com/',
    displayWebsite: 'www.spekwo.com',
    email: 'hello@spekwo.com',
    apiHost: 'https://backup.api.spekwo.com/',
    customerUrl: 'https://backup.client.spekwo.com/',
    displayCusUrl: 'backup.client.spekwo.com '
};



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/clientdash/src/environments/environment.ts